import React from 'react';
import Link from 'Components/Link';
import PropTypes from 'prop-types';
import { getInputErrorMessageValues } from '../../errors';

import styles from './InputGroup.scss';
import FormInput from 'Components/FormInput';
import ErrorIcon from './error-icon.svg';
import SuccessIcon from './success-icon.svg';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

class InputGroup extends React.Component {
  inputLabel(field) {
    const { type, fieldName, name, labelId } = field;
    if (type === 'checkbox') {
      const values =
        fieldName === 'acceptTerms'
          ? {
              privacy_policy: (
                <Link to={ROUTES.PRIVACY_POLICY} target="_blank">
                  <ConnectedFormattedMessage id="form.field.acceptTerms.privacy_policy" />
                </Link>
              ),
              terms: (
                <Link to={ROUTES.TERMS_OF_SERVICE} target="_blank">
                  <ConnectedFormattedMessage id="form.field.acceptTerms.terms" />
                </Link>
              ),
            }
          : undefined;
      return (
        <label
          htmlFor={`input-${name}`}
          className="InputGroup__label--checkbox"
        >
          <ConnectedFormattedMessage id={labelId} values={values} />
        </label>
      );
    }
    const label = labelId ? (
      <ConnectedFormattedMessage id={labelId} allowNullResponse />
    ) : (
      field.label
    );
    return (
      <label
        htmlFor={name ? `input-${name}` : null}
        className="InputGroup__label"
      >
        {label}
        {field.required ||
        field.hideOptionalFlags ||
        field.type === 'static' ? null : (
          <div className="InputGroup__optional-label">
            <ConnectedFormattedMessage id="form.field.note.optional" />
          </div>
        )}
      </label>
    );
  }

  getNote(props, showError) {
    let text;
    const { inlineMessage } = props;
    if (showError && props.errorMsgId) {
      const values = getInputErrorMessageValues(props);
      text = (
        <ConnectedFormattedMessage id={props.errorMsgId} values={values} />
      );
    } else if (showError && props.errorMsg) {
      text = props.errorMsg;
    } else if (inlineMessage) {
      text = inlineMessage.msgId ? (
        <ConnectedFormattedMessage id={inlineMessage.msgId} />
      ) : (
        inlineMessage.text
      );
    } else if (!props.required && props.fieldStyle === 'underline') {
      text = <ConnectedFormattedMessage id="form.field.note.optional" />;
    } else if (props.noteId) {
      text = <ConnectedFormattedMessage id={props.noteId} />;
    } else {
      text = props.note;
    }

    if (text) {
      let noteClass = 'InputGroup__note';
      const noteError =
        showError || (inlineMessage && inlineMessage.type === 'error');
      let noteIcon = noteError ? (
        <ErrorIcon className="InputGroup__error-icon" />
      ) : null;
      if (inlineMessage) {
        if (inlineMessage.type === 'error') noteClass += ' has-error';
        if (inlineMessage.type === 'success') {
          noteClass += ' has-success';
          noteIcon = <SuccessIcon className="InputGroup__success-icon" />;
        }
      }
      return (
        <p className={noteClass}>
          {noteIcon} {text}
        </p>
      );
    }
    return null;
  }

  getClasses(props, showError) {
    const nameClass = props.fieldName ? `InputGroup--${props.fieldName}` : '';
    const errorClass = showError ? ' has-error' : '';
    const styleClass =
      props.formStyle === 'add-user' ? ' InputGroup--add-user' : '';
    const widthClass = ` InputGroup--width-${props.fieldWidth}`;
    const sizeClass = ` InputGroup--size-${props.fieldSize}`;
    const typeClass = props.type ? ` InputGroup--type-${props.type}` : '';
    return `InputGroup ${nameClass}${typeClass}${errorClass}${styleClass}${sizeClass}${widthClass}`;
  }

  render() {
    const { labelId, label, fieldLink, ...passedProps } = this.props;
    const showError = passedProps.showError && !passedProps.isValid;
    return (
      <div className={this.getClasses(this.props, showError)}>
        {labelId || label ? this.inputLabel(this.props) : null}
        <FormInput {...passedProps} />
        <div className="InputGroup__related">
          {this.getNote(this.props, showError)}
          {fieldLink ? (
            <Link to={fieldLink.to} className="InputGroup__link">
              <ConnectedFormattedMessage id={fieldLink.textId} />
            </Link>
          ) : null}
        </div>
      </div>
    );
  }
}

InputGroup.propTypes = {
  fieldName: PropTypes.string,
  fieldWidth: PropTypes.string,
  fieldSize: PropTypes.oneOf(['small', 'large']),
  type: PropTypes.string,
};

InputGroup.defaultProps = {
  fieldWidth: 'full',
  fieldSize: 'large',
};

export default InputGroup;
